import { base64Validator } from './base64';
export const hashValidator = base64Validator({
    requiredError: 'internal.required',
    invalidFormatError: 'internal.malformed',
});
